import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { resolveBrandLogoUrl } from './resolveBrandLogoUrl';

import {
  PRODUCTS_API_KEY,
  PRODUCTS_API_URL,
} from '~/core/constants/productsApi';

export const productsApi = createApi({
  reducerPath: 'productsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: PRODUCTS_API_URL || undefined,
    prepareHeaders: (headers) => {
      if (PRODUCTS_API_KEY) {
        headers.set('X-Item', PRODUCTS_API_KEY);
      }

      return headers;
    },
  }),
  endpoints: (builder) => ({
    getBrandLogo: builder.query<string | null, string>({
      query: (brandSlug) =>
        `/Brands/by-BrandSlug/${encodeURIComponent(brandSlug)}/logo`,
      transformResponse: (response: unknown) =>
        resolveBrandLogoUrl(response, PRODUCTS_API_URL),
    }),
  }),
});

export const { useGetBrandLogoQuery } = productsApi;
